export const ProbaArtifact ={
  "_format": "hh-sol-artifact-1",
  "contractName": "ProbaContract",
  "sourceName": "contracts/ProbaContract.sol",
  "abi": [
    {
      "inputs": [],
      "stateMutability": "nonpayable",
      "type": "constructor"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "ApprovalForAll",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "assetId",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "projectId",
          "type": "bytes32"
        }
      ],
      "name": "AssetsCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "assetId",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "bytes32[]",
          "name": "documentHashes",
          "type": "bytes32[]"
        }
      ],
      "name": "AssetsValidated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "burner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "nfryId",
          "type": "uint256"
        }
      ],
      "name": "EntitlementRecordsBurned",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "sponsorAmount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "developerAmount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "nfryIds",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "string",
          "name": "statusType",
          "type": "string"
        }
      ],
      "name": "EntitlementRecordsCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "sponsorAmount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "developerAmount",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "nfryIds",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "string",
          "name": "statusType",
          "type": "string"
        }
      ],
      "name": "EntitlementRecordsUpdated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "projectId",
          "type": "bytes32"
        }
      ],
      "name": "GHGProjectCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "projectId",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "bytes32[]",
          "name": "documentHashes",
          "type": "bytes32[]"
        }
      ],
      "name": "GHGProjectValidated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "GrantedProbaRole",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "tokenIds",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        }
      ],
      "name": "PreCreditsCancellationRequested",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "sponsorAddress",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "sponsorAmount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "developerAmount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "nfryIds",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "string",
          "name": "statusType",
          "type": "string"
        }
      ],
      "name": "PreEntitlementRecordsCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "RevokedProbaRole",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "previousAdminRole",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "newAdminRole",
          "type": "bytes32"
        }
      ],
      "name": "RoleAdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleGranted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleRevoked",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        }
      ],
      "name": "TokenClaimed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "tokenIds",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "string",
          "name": "tokentype",
          "type": "string"
        }
      ],
      "name": "TokensAllocated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        }
      ],
      "name": "TokensBurned",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "bundledtradableCertificateId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "_tokenname",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "_uri",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "_ptcbIds",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "tokenCountsum",
          "type": "uint256"
        }
      ],
      "name": "TradableCertificateAllocated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "burner",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "ptcbId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "balance",
          "type": "uint256"
        }
      ],
      "name": "TradableCertificateBurned",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tradableCertificateId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "_tokenname",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "_uri",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "_nfryIds",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "_tokencount",
          "type": "uint256"
        }
      ],
      "name": "TradableCertificateCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "values",
          "type": "uint256[]"
        }
      ],
      "name": "TransferBatch",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "TransferSingle",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "string",
          "name": "value",
          "type": "string"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "URI",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "nfryId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "assetId",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "yiledId",
          "type": "bytes32"
        }
      ],
      "name": "YieldsCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "nfryIds",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "bytes32[]",
          "name": "documentHashes",
          "type": "bytes32[]"
        }
      ],
      "name": "YieldsValidated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256[]",
          "name": "nfryIds",
          "type": "uint256[]"
        },
        {
          "indexed": false,
          "internalType": "bytes32[]",
          "name": "documentHashes",
          "type": "bytes32[]"
        }
      ],
      "name": "YieldsVerified",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "DEFAULT_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "PROBA_OPERATOR",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "PROJECT_DEVELOPER",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "PROJECT_SPONSOR",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "VALIDATOR",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "VERIFIER",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "name": "assets",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "projectId",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "assetId",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "accounts",
          "type": "address[]"
        },
        {
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        }
      ],
      "name": "balanceOfBatch",
      "outputs": [
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256[]",
          "name": "_ids",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "_amounts",
          "type": "uint256[]"
        }
      ],
      "name": "burnTokens",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "tokenIds",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        },
        {
          "internalType": "string",
          "name": "tokenType",
          "type": "string"
        },
        {
          "internalType": "bytes32",
          "name": "_uri",
          "type": "bytes32"
        }
      ],
      "name": "createAllocate",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "_projectId",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32[]",
          "name": "_assetIds",
          "type": "bytes32[]"
        }
      ],
      "name": "createAssets",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256[]",
          "name": "_ids",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "_amounts",
          "type": "uint256[]"
        }
      ],
      "name": "createClaim",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "sponsorAddress",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "developerAmount",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "sponsorAmount",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "nfryIds",
          "type": "uint256[]"
        },
        {
          "internalType": "string[]",
          "name": "statusType",
          "type": "string[]"
        }
      ],
      "name": "createEntitlementRecords",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "_projectId",
          "type": "bytes32"
        }
      ],
      "name": "createGHGProject",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "_tokenname",
          "type": "bytes32"
        },
        {
          "internalType": "uint256[]",
          "name": "_tokencounts",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "_nfryIds",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes32",
          "name": "_uri",
          "type": "bytes32"
        }
      ],
      "name": "createTradableCertificate",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32[]",
          "name": "_assetIds",
          "type": "bytes32[]"
        },
        {
          "internalType": "bytes32[]",
          "name": "_yiledIds",
          "type": "bytes32[]"
        }
      ],
      "name": "createYields",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "getRoleAdmin",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "grantProbaRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "grantRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "hasRole",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        }
      ],
      "name": "isApprovedForAll",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "nfryIdCounter",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "nfryIdToEntitlement",
      "outputs": [
        {
          "internalType": "string",
          "name": "statusType",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "name": "projects",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "projectId",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "renounceRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "revokeProbaRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "revokeRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "ids",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "safeBatchTransferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "id",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "safeTransferFrom",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "operator",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "approved",
          "type": "bool"
        }
      ],
      "name": "setApprovalForAll",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "tradableCertificates",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "tokenname",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "uri",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "uri",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32[]",
          "name": "assetIds",
          "type": "bytes32[]"
        },
        {
          "internalType": "bytes32[]",
          "name": "documentHashes",
          "type": "bytes32[]"
        }
      ],
      "name": "validateAssets",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "_projectId",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32[]",
          "name": "documentHashes",
          "type": "bytes32[]"
        }
      ],
      "name": "validateGHGProject",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256[]",
          "name": "nfryIds",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes32[]",
          "name": "documentHashes",
          "type": "bytes32[]"
        }
      ],
      "name": "validateYields",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256[]",
          "name": "nfryIds",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes32[]",
          "name": "documentHashes",
          "type": "bytes32[]"
        }
      ],
      "name": "verifyYields",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "yields",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "assetId",
          "type": "bytes32"
        },
        {
          "internalType": "bytes32",
          "name": "yiledId",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}

